import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const DropdownOpenedIcon = (props) => (
    <SvgIcon {...props}>
      <polygon fill="#616161" points="6,9.429 18,9.429 12,14.571 "/>
    </SvgIcon>
);

export default DropdownOpenedIcon;



// WEBPACK FOOTER //
// ./src/icons/DropdownOpenedIcon.jsx